import { containsQuery } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/vehicle";

const getCarsAndTrailers = (params: {}) => {
    const query = containsQuery(params);
    return request(`${resource}/getCarsAndTrailers${query}`, { method: "GET" });
};

export { getCarsAndTrailers };
